module.exports = [
  // Form.
  'button',
  'input',
  'select',
  'textarea'
]



//////////////////
// WEBPACK FOOTER
// ./node_modules/rehype-minify-whitespace/content.js
// module id = 7rl8
// module chunks = 0